import { API_KEY } from '../../../../constants/loqate';
import { parents } from '../../../../util/dom';

export default class JraPayments {
  constructor(element) {
    this.element = element;

    this.isAccountVerified = false;

    this.initJraPayments();
  }


  initJraPayments() {
    this.submitButton = this.element.querySelector('[data-form="submit"]');
    this.accountName = this.element.querySelector('[data-jra-account-name-input]');
    this.accountNumber = this.element.querySelector('[data-jra-account-number-input]');
    this.sortCode = this.element.querySelector('[data-jra-sort-code-input]');

    this.inputs = [this.accountName, this.accountNumber, this.sortCode];

    this.accountVerification = this.element.querySelector('[data-jra-account-verification-validation-input]');

    this.connectionErrorMessage = this.element.dataset.jraPaymentsConnectionMessage || 'There was a problem in checking your account details, please contact us.';

    // add listeners after current stack to ensure that check validation has happened first
    setTimeout(() => {
      this.accountName.addEventListener('keyup', this.checkReadyToReleaseSubmitButton);
      this.accountNumber.addEventListener('keyup', this.checkReadyToReleaseSubmitButton);
      this.sortCode.addEventListener('keyup', this.checkReadyToReleaseSubmitButton);
      this.accountName.addEventListener('change', this.checkReadyToReleaseSubmitButton);
      this.accountNumber.addEventListener('change', this.checkReadyToReleaseSubmitButton);
      this.sortCode.addEventListener('change', this.checkReadyToReleaseSubmitButton);

    }, 0);

    this.submitButton.addEventListener('click', this.onSubmit, true);
  }


  /**
   * Here we hijack the submition of the form and if we have not verified then we
   * perform FE account validation, upon success this method is triggered
   * and submission is not prevented.
   */
  onSubmit = (event) => {
    if (!this.isAccountVerified) {
      event.preventDefault();
      this.validateAccount();
    }
  }

  submitForm() {
    const parentsNodes = parents(this.submitButton, 'form');
    if (parentsNodes && parentsNodes.length) {
      const form = parentsNodes.shift();
      form.submit();
    }
  }


  checkReadyToReleaseSubmitButton = () => {
    const allValid = this.inputs.every(input => input.checkValidity());
    this.accountVerification.checked = true; // hide validation for now
    if (allValid) {
      this.submitButton.removeAttribute('disabled');
    } else {
      this.submitButton.setAttribute('disabled', 'disabled');
    }
  }


  validateAccount = () => {
    this.accountVerification.checked = true; // hide validation for now
    this.submitButton.classList.add('Button-loading');
    const url = `https://api.addressy.com/BankAccountValidation/Interactive/Validate/v2/json3.ws?Key=${API_KEY}&AccountNumber=${this.accountNumber.value}&SortCode=${this.sortCode.value}`;

    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.Items && data.Items.length && data.Items[0].IsCorrect) {
          this.isAccountVerified = true;
          // allow the form to submit
          this.submitForm();
        } else {
          this.submitButton.classList.remove('Button-loading');
          this.accountVerification.checked = false;
          this.submitButton.setAttribute('disabled', 'disabled');
        }

        if (data.Items && data.Items.length && data.Items[0].Error) {
          alert(`${this.connectionErrorMessage}: error: ${data.Items[0].Cause}`);
          throw new Error(`Account Verfication Error: ${data.Items[0].Cause}`);
        }
      });
  }
}
